import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrl } from "../../constants";

export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const queryParams = new URLSearchParams({
      company_id: data.company_id,
    }).toString();

    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/delete_company_super?${queryParams}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Deleting Company failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteCompanySlice = createSlice({
  name: "company",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    message: null,
  },
  reducers: {
    resetDeleteCompanyStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCompany.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.message = action.payload.msg;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteCompanyStatus } = deleteCompanySlice.actions;
export default deleteCompanySlice.reducer;
